import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { AppContextConsumer } from "../../components/withAppContext";
import { styles } from "./styles";
import { HomePage } from "./sub-pages/home-page/HomePage";
import LogoutPage from "./sub-pages/logout-page/LogoutPage";
import { IProps } from "./types";

export const buttonOffset = "3px";

const Home = withStyles(styles)(
  class extends React.Component<IProps> {
    public render() {
      const { classes, loadingUserInitial, user } = this.props;

      const HomePageWithProps = () => {
        // console.log("isNewUser==========>", isNewUser)
        return (
          <HomePage loadingUserInitial={loadingUserInitial} user={user} />
        )
      };

      return (
        <Box
          className={classes.page}
          flexDirection="column"
          flexWrap="nowrap"
          justifyContent="space-between"
        >
          <Box>
            <Switch>
              <Route path="/logout" component={LogoutPage} />
              <Route path="/" component={HomePageWithProps} />
            </Switch>
          </Box>
          <Box
            position="absolute"
            bottom={10}
            left="50%"
            style={{ transform: "translate(-50%, 0%)" }}
          >
            <Typography className={classes.footerText}>
              Grit Leadership&trade; for Educational Athletics, LLC
            </Typography>
            <Typography
              className={classNames([classes.copyright, classes.footerText])}
            >
              Copyright &#169;2018-{new Date().getFullYear()} &#8226; All Rights
              Reserved
            </Typography>
          </Box>
        </Box>
      );
    }
  }
);

export default () => (
  <AppContextConsumer>{(context) => <Home {...context} />}</AppContextConsumer>
);



// WEBPACK FOOTER //
// ./src/pages/home/Home.tsx